/**
 * External Imports
 */
import styled, { css } from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuCard, NeuInput, NeuTextarea } from '@neutron/react';

interface IModalFooterProps {
  right?: boolean;
}

export const ProvisioningCard = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f6f6f6 !important;
  z-index: 10;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-inline-end: 0;
  margin-top: 0;
  width: 26em;
  min-height: 100vh;
`;

export const CardHeader = styled(NeuCard)`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  height: 56px;
  width: 100%;
  padding-top: calc(var(--card-spacing) / 2) !important;
  --background: white;
`;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
`;
export const ModalTitle = styled.h1`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #093865 !important;
`;

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  margin-top: 12px;
`;

export const ModalInput = styled(NeuInput)`
  height: 42px;
`;

export const ModalTextArea = styled(NeuTextarea)`
  font-size: 16px;
  line-height: 26px;
  color: #000000;
`;

export const ModalFooter = styled(NeuCard)<IModalFooterProps>`
  background: white !important;
  bottom: 0;
  height: 69px !important;
  ${props =>
    !props.right &&
    css`
      display: flex !important;
      justify-content: space-between !important;
    `}
`;
